export default function extEStCalcSZ(einkommen) {
  let dg_sv;
  if (einkommen > 6060) {
    einkommen = 6060;
  }
  if (einkommen > 518.44) {
    dg_sv = einkommen * 0.2048;
  } else {
    dg_sv = einkommen * 0.011;
  }
  return dg_sv;
}
